function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 2v46h36V14.594l-.281-.313-12-12L30.406 2zm2 2h20v12h12v30H9zm22 1.438L39.563 14H31zM15 22v2h20v-2zm0 6v2h16v-2zm0 6v2h20v-2z"
});

function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _ref);
}

export default SvgDocument;